<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="hero">
        <div class="hero-body">
            <div class="container">
            <h1 class="title">
                BP Control (สาขา {{ branchSelected }})
            </h1>
            </div>
        </div>
    </section>
    <div class="columns" v-show="showList">
        <div class="column" style="background-color:#FAE5D3;">
            <section class="section">
                <div class="container">
                    <h1 class="subtitle">รอประเมินราคาซ่อม</h1>
                    <article class="message" v-show="!dataAlready.start">
                        <div class="message-body">กำลังดึงข้อมูล...</div>
                    </article>
                    <table class="table" style="width:100%" v-show="dataAlready.start">
                        <thead>
                            <tr>
                              <th><abbr title="runNo">ทะเบียน</abbr></th>
                              <th><abbr title="startTime">วัน-เวลา</abbr></th>
                              <th><abbr title="action"></abbr></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="car in carList.start" v-bind:key="car.id" >
                              <td>
                                <span class="error" v-if="(car.userId === -1)">*</span>
                                <span class="car_info">({{car.licenseNo}})<br>
                                {{car.paymentMethod}}</span>
                              </td>
                              <td>{{displayDate(car.updatedAt)}} {{car.updateTime}}</td>
                              <td>
                                  <div class="buttons are-small">
                                  <button  class="button is-info" v-on:click="updateProgress($event, car.id, 'start', 'wait_approve')" v-if="car.paymentMethod==='insurance'">ถัดไป</button>
                                  <button  class="button is-info" v-on:click="openJob($event, car.id, car.licenseNo, 'start')" v-if="car.paymentMethod==='cash'">ถัดไป</button>
                                  </div>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
        <div class="column" style="background-color:#FCF3CF;">
            <section class="section">
                <div class="container">
                    <h1 class="subtitle">รอประกันอนุมัติซ่อม</h1>
                    <article class="message" v-show="!dataAlready.wait_approve">
                        <div class="message-body">กำลังดึงข้อมูล...</div>
                    </article>
                    <table class="table" style="width:100%" v-show="dataAlready.wait_approve">
                        <thead>
                            <tr>
                              <th><abbr title="startTime">ทะเบียน</abbr></th>
                              <th><abbr title="startTime">เวลา</abbr></th>
                              <th><abbr title="action"></abbr></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="car in carList.wait_approve" v-bind:key="car.id">
                              <td>
                                <span class="error" v-if="(car.userId === -1)">*</span>
                                <span class="car_info">({{car.licenseNo}})</span>&nbsp;
                              </td>
                              <td>{{displayDate(car.updatedAt)}} {{car.updateTime}}</td>
                              <td>
                                  <div class="buttons are-small">
                                      <button class="button is-info" v-on:click="openJob($event, car.id, car.licenseNo, 'wait_approve')" >ถัดไป</button>
                                  </div>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
        <div class="column" style="background-color:#FFFFD9">
            <section class="section">
                <div class="container">
                    <h1 class="subtitle">รอคิวซ่อม</h1>
                    <article class="message" v-show="!dataAlready.queue">
                          <div class="message-body">กำลังดึงข้อมูล...</div>
                    </article>
                    <table class="table" style="width:100%" v-show="dataAlready.queue">
                        <thead>
                            <tr>
                              <th><abbr title="runNo">ลำดับที่</abbr></th>
                              <th><abbr title="startTime">คาดว่า<br>จะเสร็จ</abbr></th>
                              <th><abbr title="action"></abbr></th>
                            </tr>
                        </thead>
                        <tbody>
                          <template v-for="car in carList.queue">
                            <tr v-bind:key="car.id+'_1'">
                              <td>
                                <span class="error" v-if="(car.userId === -1)">*</span>
                                {{car.jobNo}} <br><span class="car_info">({{car.licenseNo}})<br>
                                {{displayDate(car.updatedAt)}}</span>
                              </td>
                              <td>{{car.estimateDate}}</td>
                              <td>
                                  <div class="buttons are-small">
                                      <button class="button is-info" v-on:click="openSelectTechnician($event, car.id, car.licenseNo, car.jobNo, 'repair')" >ถัดไป</button>
                                  </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
        <div class="column" style="background-color:#D9F2FF">
            <section class="section">
                <div class="container">
                    <h1 class="subtitle">กำลังซ่อม</h1>
                    <article class="message" v-show="!dataAlready.repair">
                          <div class="message-body">กำลังดึงข้อมูล...</div>
                    </article>
                    <table class="table" style="width:100%" v-show="dataAlready.repair">
                        <thead>
                            <tr>
                              <th><abbr title="runNo">ลำดับที่</abbr></th>
                              <th><abbr title="startTime">คาดว่า<br>จะเสร็จ</abbr></th>
                              <th><abbr title="action"></abbr></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="car in carList.repair" v-bind:key="car.id">
                              <td>
                                <span class="error" v-if="(car.userId === -1)">*</span>
                                {{car.jobNo}} <br><span class="car_info">({{car.licenseNo}})<br>
                                {{displayDate(car.updatedAt)}}<br>
                                {{car.staffName}}, {{car.staffName_2}}
                                </span>
                              </td>
                              <td>{{car.estimateDate}}</td>
                              <td>
                                  <div class="buttons are-small">
                                    <button  class="button is-info" v-on:click="updateProgress($event, car.id, 'repair', 'finish')">ถัดไป</button>
                                  </div>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
        <div class="column" style="background-color:#D1F2EB">
            <section class="section">
                <div class="container">
                    <h1 class="subtitle">พร้อมรับรถ</h1>
                    <article class="message" v-show="!dataAlready.finish">
                          <div class="message-body">กำลังดึงข้อมูล...</div>
                    </article>
                    <table class="table" style="width:100%" v-show="dataAlready.finish">
                        <thead>
                            <tr>
                              <th><abbr title="runNo">ลำดับที่</abbr></th>
                              <th><abbr title="startTime">เสร็จ</abbr></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="car in carList.finish" v-bind:key="car.id">
                              <td>
                                <span class="error" v-if="(car.userId === -1)">*</span>
                                {{car.jobNo}} <br><span class="car_info">({{car.licenseNo}})</span>
                              </td>
                              <td>{{displayDate(car.updatedAt)}} {{car.updateTime}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </div>
    <section class="section" v-show="createJob">
      <div class="container">
          <h2 class="title is-4">กรุณากรอกรายละเอียด<br>สำหรับรถทะเบียน {{ carInfo.licenseNo }}</h2>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">ลำดับที่</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input class="input" type="text" placeholder="" v-model="carInfo.orderNo">
                </p>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">เลข Job</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input class="input" type="text" placeholder="" v-model="carInfo.jobNo">
                </p>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">เลือกประเภทงาน</label>
            </div>
            <div class="field-body">
              <div class="select">
                <select v-model="carInfo.jobType">
                  <option v-for="row in jobTypeList" v-bind:key="row.code" :value="row.code" >{{row.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">วันที่คาดว่าจะเสร็จ</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <masked-input mask="11/11/1111" class="input" type="text" placeholder="" v-model="carInfo.estimateDate" /><br>
                  <small>eg: 12/05/2020</small>
                </p>
              </div>
            </div>
          </div>
          <div class=" are-medium" style="text-align:center">
              <button class="button is-danger" v-on:click="cancelUpdate" >ยกเลิก</button>&nbsp;&nbsp;&nbsp;
              <button class="button is-info" v-on:click="updateProgress($event, carId, openJobFrom, 'queue')" >{{ btn_confirm_title }}</button>
          </div>
      </div>
    </section>

    <section class="section" v-show="selectTechnician">
        <div class="container">
            <h2 class="title is-4">กรุณาเลือกช่าง<br>สำหรับงาน {{ carInfo.jobNo }} ({{ carInfo.licenseNo }})</h2>
            <h3 class="">
              ช่างคนที่ 1
            <div class="select">
                <select v-model="staffId">
                  <option v-for="staff in staffList.technician" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
                </select>
            </div><br><br><br>
            ช่างคนที่ 2
            <div class="select">
                <select v-model="staffId_2">
                  <option v-for="staff in staffList.technician" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
                </select>
            </div><br><br>
            <div class=" are-medium" style="text-align:center">
                <button class="button is-danger" v-on:click="cancelUpdate" >ยกเลิก</button>&nbsp;&nbsp;&nbsp;
                <button class="button is-info" v-on:click="updateProgress($event, carId, 'queue', 'repair')" >{{ btn_confirm_title }}</button>
            </div>
            </h3>
        </div>
      </section>

      <section class="section" v-show="selectLeader">
        <div class="container">
            <h2 class="title is-4">กรุณาเลือกผู้ตรวจสอบ<br>สำหรับงาน {{ carInfo.runNo }} <br>ทะเบียน {{ carInfo.licenseNo }}</h2>
            <h3 class="">
            <div class="select">
                <select v-model="leaderId">
                <option v-for="staff in staffList.leader" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
                </select>
            </div><br><br>
            <div class=" are-medium" style="text-align:center">
                <button class="button is-danger" v-on:click="cancelUpdate" >ยกเลิก</button>&nbsp;&nbsp;&nbsp;
                <button class="button is-info" v-on:click="updateProgress($event, carId, frommethod, action_select)" >{{ btn_confirm_title }}</button>
            </div>
            </h3>
        </div>
      </section>
      <span class="error">{{ error_msg }}</span>
  </div>
</template>
<style>
.banner {
  text-align: center;
  background-color: #000;
}
.hero-body {
  padding: 1.5rem 1.5rem !important;
}
.section {
  padding: 1rem .2rem !important;
}
td {
  font-size: 14px !important;
}
.car_info {
  color: #888;
  font-size: 12px;
}
.error {
  color: red;
}
input[type=checkbox] {
  padding: 10px;
          transform: scale(2);

  -webkit-transform: scale(2); /* Safari and Chrome */
     -moz-transform: scale(2); /* FF */
  /* Double-sized Checkboxes */
      -ms-transform: scale(2); /* IE */
       -o-transform: scale(2); /* Opera */
}

/* Might want to wrap a span around your checkbox text */
.checkboxtext {
  display: inline;
  /* Checkbox text */
  font-size: 110%;
}
</style>
<style scoped>
.subtitle {
  font-weight: bold;
}
</style>
<script>
import MaskedInput from 'vue-masked-input'

export default {
  name: 'Home',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {
    MaskedInput
  },
  data: () => ({
    dataAlready: {
      'start': false,
      'wait_approve': false,
      'queue': false,
      'repair': false,
      'finish': false
    },
    confirmSuccess: false,
    openJobFrom: '',
    showList: true,
    createJob: false,
    selectTechnician: false,
    selectLeader: false,
    selectRepairExtra: false,
    inputCost: false,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    jobTypeList: [
      { 'code': 'Q', 'name': 'Q' },
      { 'code': 'M', 'name': 'M' },
      { 'code': 'H', 'name': 'H' },
      { 'code': 'Super Quick', 'name': 'Super Quick' }
    ],
    branch: [],
    step: [
      {
        current: 'start',
        title: 'รอประเมินราคาซ่อม',
        nextstep: [{
          title: 'รอประกันอนุมัติซ่อม',
          action: 'wait_approve'
        }]
      },
      {
        current: 'wait_approve',
        title: 'รอประกันอนุมัติซ่อม',
        nextstep: [{
          title: 'รอคิวซ่อม',
          action: 'queue'
        }]
      },
      {
        current: 'queue',
        title: 'รอคิวซ่อม',
        nextstep: [{
          title: 'กำลังซ่อม',
          action: 'repair'
        }]
      },
      {
        current: 'repair',
        title: 'กำลังซ่อม',
        nextstep: [{
          title: 'พร้อมรับรถ',
          action: 'finish'
        }]
      },
      {
        current: 'finish',
        title: 'พร้อมรับรถ'
      }
    ],
    stepCurrent: {},
    branchSelected: '',
    branchCode: '',
    carInfo: {
      jobNo: '',
      orderNo: '',
      jobType: '',
      estimateDate: '',
      branchId: '',
      customerName: '',
      frameNo: '',
      licenseNo: '',
      expectedDate: '',
      expectedTime: '',
      customerWait: false
    },
    carId: '',
    carList: {
      'start': [],
      'wait_approve': [],
      'queue': [],
      'repair': [],
      'finish': []
    },
    staffList: {
      'technician': [],
      'leader': []
    },
    current_step: '',
    staffId: '',
    staffId_2: '',
    partWait: false,
    leaderId: '',
    extra_staffId: '',
    extra_staffId_2: '',
    extra_leaderId: '',
    btn_confirm_title: 'ยืนยัน',
    action_select: '',
    cost_total: '',
    cost_ids: '',
    cost_system_pro: '',
    error_msg: '',
    t: null,
    frommethod: '',
    updatedBy: ''
  }),
  mounted () {
    let _this = this
    _this.updatedBy = this.$session.get('vgroup')
    _this.branch = this.$branchList
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    _this.branchCode = params.get('branchCode')
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    _this.getCarList('start')
    _this.getCarList('wait_approve')
    _this.getCarList('queue')
    _this.getCarList('repair')
    _this.getCarList('finish')
    _this.getTechnician()
    _this.getLeader()
    _this.autoReload()
  },
  methods: {
    autoReload () {
      let _this = this
      _this.t = setInterval(() => {
        _this.getCarList('start')
        _this.getCarList('wait_approve')
        _this.getCarList('queue')
        _this.getCarList('repair')
        _this.getCarList('finish')
      }, 120 * 1000)
    },
    stopReload () {
      clearInterval(this.t)
    },
    getCarList (step) {
      let _this = this
      _this.dataAlready[step] = false
      this.$axios
        .get(`${this.$apiUrl}getCarProgressBP?current=${step}&branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready[step] = true
          _this.carList[step] = response.data
          _this.selectTechnician = false
          _this.selectLeader = false
          _this.selectRepairExtra = false
          _this.inputCost = false
          _this.showList = true
          _this.btn_confirm_title = 'ยืนยัน'
          _this.staffId = ''
          _this.staffId_2 = ''
          _this.createJob = false
          _this.partWait = false
          _this.leaderId = ''
          _this.extra_staffId = ''
          _this.extra_staffId_2 = ''
          _this.extra_leaderId = ''
          _this.error_msg = ''
        })
    },
    getTechnician () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=Technician`)
        .then(response => {
          _this.staffList['technician'] = response.data
        })
    },
    getLeader () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=Technician Leader`)
        .then(response => {
          _this.staffList['leader'] = response.data
        })
    },
    cancelUpdate () {
      this.autoReload()
      this.selectTechnician = false
      this.selectLeader = false
      this.selectRepairExtra = false
      this.showList = true
      this.carId = ''
      this.carInfo.licenseNo = ''
      this.carInfo.runNo = ''
      this.staffId = ''
      this.staffId_2 = ''
      this.partWait = false
      this.extra_staffId = ''
      this.extra_staffId_2 = ''
      this.extra_leaderId = ''
      this.leaderId = ''
    },
    openJob (event, carId, licenseNo, from) {
      this.stopReload()
      this.openJobFrom = from
      this.createJob = true
      this.showList = false
      this.carId = carId
      this.carInfo.licenseNo = licenseNo
    },
    openSelectTechnician (event, carId, licenseNo, jobNo) {
      this.stopReload()
      this.selectTechnician = true
      this.showList = false
      this.carId = carId
      this.carInfo.licenseNo = licenseNo
      this.carInfo.jobNo = jobNo
    },
    openSelectRepairExtra (event, carId, licenseNo, runNo, action) {
      this.stopReload()
      this.selectRepairExtra = true
      this.showList = false
      this.carId = carId
      this.carInfo.licenseNo = licenseNo
      this.carInfo.runNo = runNo
      this.action_select = action
    },
    openSelectLeader (event, carId, licenseNo, runNo, frommethod, action) {
      this.stopReload()
      this.selectLeader = true
      this.showList = false
      this.carId = carId
      this.carInfo.licenseNo = licenseNo
      this.carInfo.runNo = runNo
      this.action_select = action
      this.frommethod = frommethod
    },
    updateProgress (event, carId, currentStep, nextStep) {
      this.stopReload()
      let _this = this
      // if (nextStep === 'repair' && _this.staffId === '') {
      //   _this.error_msg = 'กรุณาระบุช่าง'
      //   return false
      // } else if (nextStep === 'cleaning' && _this.leaderId === '') {
      //   _this.error_msg = 'กรุณาระบุผู้ตรวจสอบ'
      //   return false
      // } else if (nextStep === 'repair_extra' && (_this.extra_leaderId === '' || _this.extra_staffId === '')) {
      //   _this.error_msg = 'กรุณาระบุผู้ตรวจสอบ และ ช่างคนที่ 1'
      //   return false
      // }
      _this.btn_confirm_title = 'กำลังดำเนินการ'
      _this.carId = carId
      let params = {
        carId: _this.carId,
        current: currentStep,
        nextStep: nextStep,
        staffId: _this.staffId,
        staffId_2: _this.staffId_2,
        leaderId: _this.leaderId,
        updatedBy: _this.updatedBy,
        orderNo: _this.carInfo.orderNo,
        jobNo: _this.carInfo.jobNo,
        jobType: _this.carInfo.jobType,
        estimateDate: _this.carInfo.estimateDate
      }
      this.$axios
        .post(`${this.$apiUrl}updateProgressBP`, params)
        .then(response => {
          _this.updateSuccess = true
          _this.getCarList('start')
          _this.getCarList('wait_approve')
          _this.getCarList('queue')
          _this.getCarList('repair')
          _this.getCarList('finish')
          _this.autoReload()
        })
    },
    displayDate (timestamp) {
      const now = new Date(timestamp)
      return `${now.getDate()}-` + (now.getMonth() + 1) + `-${now.getFullYear()}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WorkshopBP.vue